export default class createWebhookOverlay {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/setting/modal/createWebhook.html'),
            scope: {
                show: '=',
                events: '='
            },
            controller: CreateWebHookCtrl,
            controllerAs: 'hook'
        }
    }
};

class CreateWebHookCtrl {
    constructor($scope, $filter, Setting, Events) {
        this._scope = $scope;
        this._translator = $filter('translate');

        this.settingsRepo = Setting;
        this.eventHandler = Events;

        this.createMore = false;

        $(document).keyup((e) => {
            if (e.keyCode == 27) {
                this._scope.show = false;
                this._scope.$apply(); // Close modal on escape.
            }
        });
    }

    toggleCreateMore() {
        this.createMore = $('#createMoreBtn').is(':checked');
    };

    toggleShow() {
        this._scope.show = ! this._scope.show;
    };

    save() {
        if (this.webhook.url && this.webhook.event) {
            this.settingsRepo.createWebhook(this.webhook.event, this.webhook.url).then(() => {
                this.eventHandler.flashEvent('notification', this._translator('SETTING:FLASH:WEBHOOK_CREATED'));
                this._scope.$emit('setting:newWebHook');

                if (! this.createMore) {
                    this.toggleShow(); // Close modal.
                } else {
                    this.webhook = {};
                }
            }, (error) => {
                if (error.status === 400) {
                    this.eventHandler.flashEvent('error', this._translator('SETTING:FLASH:INVALID_WEBHOOK_URL'));
                } else {
                    this.eventHandler.flashEvent('error', this._translator('SETTING:FLASH:INVALID_WEBHOOK'))
                }
            });
        } else {
            this.eventHandler.flashEvent('error', this._translator('SETTING:FLASH:INVALID_WEBHOOK'));
        }
    }
}
